// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_sales_sales_module_ts":"d5234e9ee943b4a2","node_modules_echarts_index_js":"92621091de68e9e4","quill":"c394ba78a4c4f967"}[chunkId] + ".js";
};